import { useUserPreferences } from './useUserPreferences';

const PREFERENCE_KEY = 'presentationMode';

export type PresentationMode =
  | /**
   * Normal is the default mode, where all feature flags are respected.
   */
  'normal'
  /**
   * Demo mode is a special mode where certain feature flags are treated as disabled, regardless of their actual state.
   * This is useful for showcasing the application without exposing features that may not be relevant in a demo context or might not be generally available.
   */
  | 'demo';

export function usePresentationMode() {
  const { getPreference, updatePreference, removePreference } = useUserPreferences();

  const getPresentationMode = (): PresentationMode => {
    return getPreference(PREFERENCE_KEY) === 'demo' ? 'demo' : 'normal';
  };

  const setPresentationMode = (mode: PresentationMode) => {
    if (mode === 'demo') {
      updatePreference(PREFERENCE_KEY, 'demo');
    } else {
      removePreference(PREFERENCE_KEY);
    }
  };

  return { getPresentationMode, setPresentationMode };
}
